import axios, { AxiosResponse } from "axios";
import { getToken } from "../../api/Api";

export type BotResponse = {
   status: "queued" | "running" | "finished" | "failed";
   progress?: number;
   first_results_uploaded?: boolean;
   find_new_place_called?: boolean;
   match_places_in_progress?: boolean;
   places?: unknown[];
   error_message?: string;
   warnings?: string[];
};

const sleep = (timeMs: number) => new Promise<void>((resolve) => setTimeout(resolve, timeMs));

type SendRequestOptions = {
   onPollResponse?: (response: AxiosResponse<BotResponse>) => void;
   delayMs?: number;
};

export const sendRequest = async (
   userMessage: string,
   coordinates: string,
   radius: number,
   options: SendRequestOptions = {},
): Promise<AxiosResponse<BotResponse>> => {
   const { onPollResponse, delayMs = 2000 } = options;

   const placefinderToken = await getToken();

   const prepareToken = placefinderToken.data.getSingleUseToken.token;

   const commonHeaders = {
      Accept: "*/*",
      "Content-Type": "application/json",
      Authorization: "Token a193149862faf73ff9dcaccb1028a3950f686fe1",
   };

   const getProcessKey = await axios.post(
      "https://bpower2.place-finder.vmt.com.pl/api/places/jobs/",
      {
         "single-use-token": prepareToken,
         location: coordinates,
         radius: radius,
         description: userMessage,
         type: "restaurant",
         project: "foodbi",
      },
      {
         headers: commonHeaders,
      },
   );
   onPollResponse?.(getProcessKey);
   const { process_key } = getProcessKey.data;
   if (!process_key) {
      throw new Error("No process_key returned from API");
   }

   while (true) {
      const pollResponse = await axios.get<BotResponse>(
         `https://bpower2.place-finder.vmt.com.pl/api/places/jobs/${process_key}/`,
         {
            headers: commonHeaders,
         },
      );

      onPollResponse?.(pollResponse);

      const status = pollResponse?.data?.status;

      if (status === "failed") {
         const message = pollResponse.data?.error_message || "Job failed";
         throw new Error(message);
      }

      if (status === "finished") {
         return pollResponse as AxiosResponse<BotResponse>;
      }

      await sleep(delayMs);
   }
};
